








































import { Vue, Component, Prop } from "vue-property-decorator";
import NewInputDialog from "./NewInputDialog.vue";
import { TemplateInput } from "@/store/template/types";
import { INPUT_TYPES } from "@/store/template/types";

@Component({
  components: {
    NewInputDialog
  }
})
export default class InputTile extends Vue {
  // Vuex store with lightweight typed wrapper
  readonly store = this.$store.direct;
  // Component Attributes
  @Prop() input!: TemplateInput;
  @Prop() inputIndex!: number;
  @Prop() sectionIndex!: number;

  get type() {
    let _type = INPUT_TYPES.find(item => {
      return item.value == this.input.type;
    });
    console.log(this.input.type);
    return _type ? _type.label : "";
  }
  // Component Methods
  remove() {
    this.store.commit.template.REMOVE_INPUT_FROM_SECTION({
      inputIndex: this.inputIndex,
      section: this.sectionIndex
    });
  }
}
